module.exports = __webpack_public_path__ + "img/promo-popup-image.8c2cec8b.svg";